import Vue from 'vue'
import { state } from '../renamePopup'

export default{
    init(state, data) {
        state.data = data
    }
}